var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-rounded is-large",class:[
    ("is-" + _vm.bgColor),
    _vm.themedClass,
    ( _obj = {
      'is-loading': _vm.loading,
      'is-fullwidth-on-mobile': _vm.text,
      'min-width': _vm.text && _vm.minWidth,
    }, _obj[("variant-" + _vm.variantOverride)] = _vm.variantOverride, _obj ) ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick($event)}}},[(_vm.icon)?_c('div',{class:{ 'add-right-padding': _vm.text },staticStyle:{"display":"flex"}},[_c('LsIcon',{attrs:{"type":_vm.icon,"color":_vm.normalizedTextColor}})],1):_vm._e(),(_vm.text)?_c('span',{staticClass:"is-size-5 has-text-weight-bold",class:[
      ( _obj$1 = {}, _obj$1['is-uppercase'] = _vm.isUppercase, _obj$1 ) ]},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
var _obj;
var _obj$1;}
var staticRenderFns = []

export { render, staticRenderFns }